import { Column, Entity, PrimaryColumn } from 'typeorm';

import { Mark } from '../../_objects/mark';
import { TenantIdSchemaBase } from '../interfaces/tenantId.base';

/**
 * MarkSchema インターフェイス。
 */
export interface IMarkSchema {
  tenantId: string;
  id: string;
  items: string;
  isDeleted: boolean;
  isValid: boolean;
  createDate: string;
  createdBy: string;
  lastUpdateDate: string;
  lastUpdatedBy: string;
  schemaVersion: string;
}

@Entity()
export class MarkSchema implements TenantIdSchemaBase, IMarkSchema {
  @PrimaryColumn()
    tenantId: string;

  @Column({ nullable: true })
    id: string | null;

  @Column({ nullable: true })
    items: string | null;

  @Column({ nullable: true })
    isDeleted: boolean | null;

  @Column({ nullable: true })
    isValid: boolean | null;

  @Column({ nullable: true })
    createDate: string | null;

  @Column({ nullable: true })
    createdBy: string | null;

  @Column({ nullable: true })
    lastUpdateDate: string | null;

  @Column({ nullable: true })
    lastUpdatedBy: string | null;

  @Column({ nullable: true })
    schemaVersion: string | null;

  constructor(tenantId: string, mark?: Mark) {
    if (mark) {
      this.tenantId = tenantId;
      this.id = mark.id;
      this.items = mark.items ? JSON.stringify(mark.items) : null;
      this.isDeleted = mark.isDeleted;
      this.isValid = mark.isValid;
      this.createDate = mark.createDate;
      this.createdBy = mark.createdBy;
      this.lastUpdateDate = mark.lastUpdateDate;
      this.lastUpdatedBy = mark.lastUpdatedBy;
      this.schemaVersion = mark.schemaVersion;
    }
  }
}
